import React, { ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";
import styled from "@emotion/styled";

const InputContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

const InputWrapper = styled.div({
  position: "relative",
});

const Input = styled.input<{ maxWidth?: string; fontSize?: string }>(
  ({ theme, width, height, maxWidth, fontSize }) => ({
    width: width,
    maxWidth: maxWidth ? maxWidth : "",
    height: height,
    border: `1px solid ${theme.color.light_gray}`,
    padding: "1.6rem",
    borderRadius: "0",
    fontFamily: "Pretendard ,Sans-serif",
    fontSize: fontSize ? fontSize : "1.4rem",
  }),
);

interface CustomTextInputProps {
  name: string;
  type?: string;
  errorMessage?: string;
  width?: string;
  height?: string;
  placeholder?: string;
  alwaysShowMessage?: boolean;
  message?: string;
  serverError?: string;
  serverSuccess?: boolean;
  value?: string;
  readOnly?: boolean;
  hidden?: boolean;
  children?: React.ReactNode;
  error?: boolean;
  maxWidth?: string;
  defaultValue?: string;
  mode?:
    | "none"
    | "text"
    | "decimal"
    | "numeric"
    | "tel"
    | "search"
    | "email"
    | "url";
  dir?: "rtl" | "ltr";
  max?: number;
  onInput?: (e: any) => void;
  onKeyDown?: (e: any) => void;
  onlyText?: boolean;
  fontSize?: string;
}

const BasicFormInput: React.FC<CustomTextInputProps> = ({
  name,
  type = "text",
  height = "5.2rem",
  width = "100%",
  placeholder = "",
  maxWidth,
  value = "",
  readOnly = false,
  hidden,
  children,
  mode = "text",
  dir = "ltr",
  defaultValue,
  max,
  onKeyDown,
  onInput,
  fontSize,
}) => {
  const { register, setValue } = useFormContext();

  // const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
  //   {
  //     const newValue =
  //       type === "number"
  //         ? e.target.value === ""
  //           ? ""
  //           : Number(e.target.value)
  //         : e.target.value;

  //     setValue(name, newValue);
  //   }
  // };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let newValue;

    if (type === "number") {
      // 숫자 타입 처리
      newValue = e.target.value === "" ? "" : Number(e.target.value);
    } else if (name === "account_number") {
      // 계좌번호 특별 처리 - 숫자만 허용하되 문자열로 유지
      newValue = e.target.value.replace(/[^0-9]/g, "");
    } else {
      // 일반 텍스트 타입
      newValue = e.target.value;
    }

    setValue(name, newValue);
  };

  return (
    <InputContainer>
      <InputWrapper>
        <Input
          id={name}
          type={type}
          {...register(name)}
          height={height}
          width={width}
          placeholder={placeholder}
          value={value === "" ? undefined : value}
          readOnly={readOnly}
          hidden={hidden}
          inputMode={mode}
          maxWidth={maxWidth}
          dir={dir}
          onChange={handleChange}
          defaultValue={defaultValue}
          maxLength={max}
          onKeyDown={onKeyDown}
          onInput={onInput}
          fontSize={fontSize}
        />

        <span>{children}</span>
      </InputWrapper>
    </InputContainer>
  );
};

export default BasicFormInput;
